import React, { Component } from 'react';

class IconEditBlue extends Component {
    render() {
        return (
            <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1289_896)">
                    <path d="M13.0079 1.62196e-07C10.5681 -0.000395399 8.18286 0.722737 6.15397 2.07795C4.12509 3.43316 2.54364 5.35958 1.60962 7.6136C0.675601 9.86762 0.430963 12.348 0.906643 14.741C1.38232 17.1341 2.55696 19.3323 4.282 21.0578C6.00704 22.7833 8.20501 23.9584 10.5979 24.4347C12.9909 24.911 15.4713 24.6669 17.7256 23.7335C19.9798 22.8 21.9066 21.219 23.2623 19.1905C24.618 17.1619 25.3417 14.7769 25.3419 12.337C25.3425 10.717 25.0238 9.11274 24.4042 7.61591C23.7846 6.11907 22.8761 4.75897 21.7307 3.61331C20.5854 2.46765 19.2255 1.55887 17.7288 0.938889C16.2321 0.318907 14.6279 -0.000131279 13.0079 1.62196e-07V1.62196e-07Z" fill="#2155A3" />
                    <path d="M5.95898 16.0114V18.9474H8.89498L17.555 10.2874L14.619 7.35543L5.95898 16.0114ZM19.826 8.01743C19.9713 7.87128 20.0529 7.67355 20.0529 7.46743C20.0529 7.26132 19.9713 7.06358 19.826 6.91743L17.994 5.08043C17.8478 4.9351 17.6501 4.85352 17.444 4.85352C17.2379 4.85352 17.0401 4.9351 16.894 5.08043L15.459 6.51343L18.395 9.44943L19.826 8.01743Z" fill="white" />
                </g>
                <defs>
                    <clipPath id="clip0_1289_896">
                        <rect width="24.671" height="24.671" fill="white" transform="translate(0.671875)" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconEditBlue;